<nav class="navbar navbar-default" style="height:50px;display: flex;flex-flow: row wrap;align-items: center;justify-content: space-between;">
    <div class="navbar-header">
        <h3 [routerLink]="['/vertrag/impressum']">Impressum</h3>
    </div>
</nav>
<mat-card-content style="height: calc(100vh - 180px);">
    <p>
        NEPRAUNIK & PRAMMER <br/>

        Rechtsanwälte GesbR <br/>
    </p>
    <p class="seperator-line"></p>
    <p>
      <b>Kanzleigründer:</b> Dr. Axel Nepraunik (emeritiert) <br />
      <b>Partner:</b> RA Mag. Wolfgang Prammer, RA Mag. Martin Nepraunik, LL.M., RA Dr. Leonhard Göbel, RA Dr. Franz Reinthaler <br />
      <b> Ständige Substituten:</b> RA Mag. Sandra Justin, RA Mag. Thomas Breite, RA Mag. Barbara Ganotz <br />
      <b>UID-Nummer:</b> ATU 57079547 <br />
      <b>DVR-Nummer:</b> 2109388<br />
      Als österreichische Rechtsanwälte unterliegen wir der Aufsicht der Rechtsanwaltskammer Wien und dem Standesrecht für Rechtsanwälte (RAO, RL-BA, u.a. abrufbar unter <a href="www.oerak.at">www.oerak.at</a>).<br />
      Alle Personen- und Funktionsbezeichnungen auf dieser Website, die in männlicher Form verwendet werden, gelten sinngemäß auch in der weiblichen Form. <br />
      Gegründet 1979 <br />
    </p>

</mat-card-content>



// WEBPACK FOOTER //
// ./src/app/_vertrag/impressum/impressum.component.html